// 应用框架hooks
import { useHistory, useLocation } from "react-router"
import { useCacheUser } from "Hooks/user"
import { getUserLocalInfo } from "Methods/user"

// 判定用户落地页
export const homePath = "/"
const weChatPath = "/wechat"
const financePath = "/finance"
const defaultPath = "/calendar"
export function usePickUserLandingPage() {
    const { pathname } = useLocation()
    const history = useHistory()
    const { token, uid } = getUserLocalInfo()
    const { fetchUser, user } = useCacheUser({
        access_token: token,
        uid,
    })
    if (pathname === homePath && user) {
        const { role } = user
        const { role_name } = role || {}
        const isTrueEditor = role_name === "true_editor"
        const isSideEditor = role_name === "side_editor"
        const isOpEditor = role_name === "op_editor"
        const isFinance = role_name === "finance"
        let redirectPath = ""
        if (role_name) {
            if (isFinance) {
                redirectPath = financePath
            } else if (isTrueEditor || isSideEditor || isOpEditor) {
                redirectPath = weChatPath
            } else {
                redirectPath = defaultPath
            }
            setTimeout(() => {
                history.push(redirectPath)
            })
        }
    }
    return { fetchUser, user }
}
